import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/auth/LoginPage';
import ConferenceMap from './ConferenceMap';
import ManagerPerformanceDashboard from './components/dialogs/ManagerPerformanceDashboard';
import useClientData from './hooks/useClientData';
import './App.css';


// Main app component that handles authentication state
const AppContent = () => {
  const { isAuthenticated, isLoading, login, logout, user } = useAuth();
  const { clientData } = useClientData();
  const [showManagerDashboard, setShowManagerDashboard] = useState(false);

  useEffect(() => {
    function openDashboardHandler() {
      setShowManagerDashboard(true);
    }
    window.addEventListener("openManagerPerformanceDashboard", openDashboardHandler);
    return () => window.removeEventListener("openManagerPerformanceDashboard", openDashboardHandler);
  }, []);

  function handleCloseDashboard() {
    setShowManagerDashboard(false);
  }

  // Show loading spinner while checking authentication status
  if (isLoading) {
    return (
      <div className="App">
        <div className="auth-loading">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage onLogin={login} />;
  }

  // Show main app if authenticated
  return (
    <>
      <div className="App">
        {/* Optional: Add logout functionality to the main app */}
        <div className="auth-status" style={{ display: 'none' }}>
          <span>Logged in as: {user?.username || user}</span>
          <button onClick={logout} className="logout-button">
            Logout
          </button>
        </div>
        <ConferenceMap />
      </div>
      {showManagerDashboard && (
        <ManagerPerformanceDashboard
          clientData={clientData}
          onClose={handleCloseDashboard}
        />
      )}
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
